import { Instance, types } from "mobx-state-tree";
import { intentStoreGetter } from "../../utils";

export const Intent = types
  .model("Intent", {
    type: types.string,
    probability: types.number
  })
  .views(intentStoreGetter)
  .views((self) => ({
    get intentSuggestion() {
      return self.intentStore.allIntentSuggestions.find((intent) => intent.intent === self.type);
    },
    get displayName() {
      return self.type;
    }
  }));

export interface IIntent extends Instance<typeof Intent> { }
